// src/EmployeeList.js ver 00
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './App'; // Assuming useAuth is exported from App.js
import * as employeeService from './api/employeeService';
// import PaginationBar from './PaginationBar'; // Ensure this path is correct
// import PaginationBar from './App'; // Ensure this path is correct
import PaginationBar2 from './PaginationBar2'; // Ensure this path is correct

function EmployeeList() {
    const [employees, setEmployees] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const auth = useAuth();

    // NEW: Pagination State
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(20);
    const [totalItems, setTotalItems] = useState(0);
    const [totalPages, setTotalPages] = useState(1);

    const TENANT_ID = auth.userProfile?.SubsCoDocId;
    console.log(`EmployeeList.js TENANT_ID: ${TENANT_ID}`);

    useEffect(() => {
        const fetchEmployees = async () => {
            if (!TENANT_ID) {
                setError("No associated company found. Please create one.");
                setLoading(false);
                return;
            }
            setLoading(true);
            setError(null);
            try {
                const token = await auth.getIdToken();
                if (!token) {
                    setError("Authentication required. Please log in.");
                    setLoading(false);
                    return;
                }
                console.log(`EmployeeList: token = ${token}`)
                const response = await employeeService.getEmployees(TENANT_ID, token, currentPage, itemsPerPage);
                setEmployees(response.employees); // Note data is in "employees" field from backend
                setTotalItems(response.totalItems);
                setTotalPages(response.totalPages);
            } catch (err) {
                console.error("Error fetching employees from Cloud Function: ", err);
                setError(`Failed to load employees: ${err.message}`);
            } finally {
                setLoading(false);
            }
        };
        fetchEmployees();
    }, [auth, TENANT_ID, currentPage, itemsPerPage]);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const handleLimitChange = (newLimit) => {
        setItemsPerPage(newLimit);
        setCurrentPage(1); // Reset to first page when limit changes
    };

    if (loading) return <p>Loading employees...</p>;
    if (error) return <p style={{ color: 'red' }}>Error: {error}</p>;
    if (!TENANT_ID) return <p style={{ color: 'orange' }}>Please create a company profile to manage employees.</p>;


    return (
        <div>
            <div className="page-header">
                <h2>Employee List</h2>
                {/* <Link to={`/employees/add/${TENANT_ID}`} className="btn secondary">Add New Employee</Link> */}
                <Link to={`/employees/add`} className="btn secondary">Add New Employee</Link>
            </div>

            <PaginationBar2
                currentPage={currentPage}
                totalPages={totalPages}
                itemsPerPage={itemsPerPage}
                totalItems={totalItems}
                onPageChange={handlePageChange}
                onLimitChange={handleLimitChange}
            />

            <table>
                <thead>
                    <tr>
                        <th>Employee ID</th>
                        <th>Full Name</th>
                        <th>AuthLoginName</th>
                        <th>Employee Role</th>
                        <th>Employee Status</th>
                        <th>Type</th>
                    </tr>
                </thead>
                <tbody>
                    {employees.map(employee => (
                        <tr key={employee.id}>
                            <td>{employee.EmployeeId}</td>
                            {/* <td><Link to={`/employees/edit/${TENANT_ID}/${employee.id}`}>{employee.FullName}</Link></td> */}
                            <td><Link to={`/employees/edit/${employee.id}`}>{employee.FullName}</Link></td>
                            <td>{employee.AuthLoginName}</td> 
                            <td>{employee.EmployeeRole}</td>
                            <td>{employee.EmployeeStatus}</td>
                            <td>{employee.Type}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <PaginationBar2
                currentPage={currentPage}
                totalPages={totalPages}
                itemsPerPage={itemsPerPage}
                totalItems={totalItems}
                onPageChange={handlePageChange}
                onLimitChange={handleLimitChange}
            />
        </div>
    );
}

export default EmployeeList;